import * as actionTypes from "../store/actions/actionTypes";

const funcActions = prefix => {
  const start = () => {
    return {
      type: actionTypes[`${prefix}_START`]
    };
  };

  const success = () => {
    return {
      type: actionTypes[`${prefix}_SUCCESS`]
    };
  };

  const fail = error => {
    return {
      type: actionTypes[`${prefix}_FAIL`],
      error: error
    };
  };

  return {
    start,
    success,
    fail
  };
};

export default funcActions;
